import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageIntro } from "@/components/site/PageIntro";

export const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export const PostCard = ({ post }) => {
  const { user } = useAuth();
  return (
    <article data-testid={`blog-card-${post.slug}`} className="card-soft overflow-hidden grid md:grid-cols-5 hover:border-[#b6689a]">
      {post.image && <img src={post.image} alt={post.title} className="md:col-span-2 h-72 md:h-full w-full object-cover" />}
      <div className={`${post.image ? "md:col-span-3" : "md:col-span-5"} p-8 sm:p-10 flex flex-col`}>
        <span className="eyebrow">{fmtDate(post.published_at)}</span>
        <h2 className="font-serif-h text-3xl sm:text-4xl text-[#577731] mt-3 leading-tight">{post.title}</h2>
        <p className="mt-5 text-[#232b1b]/75 leading-relaxed">{post.preview}</p>
        <div className="mt-8">
          {user ? (
            <Link to={`/blog/${post.slug}`} data-testid={`blog-read-${post.slug}`} className="btn btn-olive">Read the Full Teaching</Link>
          ) : (
            <Link to={`/ambassadors?next=/blog/${post.slug}#join`} data-testid={`blog-gate-${post.slug}`} className="btn btn-mauve">Apply to Become a Healing Ambassador to keep reading</Link>
          )}
        </div>
      </div>
    </article>
  );
};

export default function Blog() {
  const [posts, setPosts] = useState(null);
  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data));
  }, []);
  return (
    <div data-testid="blog-page">
      <PageIntro eyebrow="The Ambassadors Blog" title="Teachings, ceremony reflections, and wisdom for the path" testid="blog-title" />
      <section className="max-w-6xl mx-auto px-6 lg:px-10 space-y-8">
        {posts === null && <p className="text-[#232b1b]/60">Gathering the teachings…</p>}
        {posts?.length === 0 && <p className="text-[#232b1b]/60">New teachings are being written.</p>}
        {posts?.map((p) => <PostCard key={p.id} post={p} />)}
      </section>
    </div>
  );
}
